@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form">
  <div class="row g-3">
    <div class="col-sm-1 mt-2">
      <input-field type="text" [inputFormControl]="getItemCodeInput()" label="Code" placeholder="Code" />
    </div>
    <div class="col-sm-4 mt-2">
      <select-field [selectFormControl]="getItemJurisdictionInput()" [options]="jurisdictionsOptions"
      label="Jurisdictions"></select-field>
    </div>
    <div class="col-sm-3 mt-2">
      <select-field [selectFormControl]="getItemProductInput()" [options]="itemProductsOptions"
      label="Product"></select-field>
    </div>
    <div class="col-sm-4 mt-2">
      <select-field [selectFormControl]="getItemTypeInput()" [options]="itemTypesOptions" label="Type"></select-field>
    </div>
    <div class="col-sm-2 mt-2">
      <input-field type="number" [inputFormControl]="getItemPriceInput()" label="Price" placeholder="Price"
        suffix="€" />
    </div>
    <div class="col-sm-1 mw-field mt-2">
      <input-field type="number" [inputFormControl]="getItemMaxDiscountInput()" label="Max Discount"
        placeholder="Max Discount" suffix="%" />
    </div>
    <div class="col-sm-2 mt-2">
      <input-field type="number" [inputFormControl]="getItemOperatingCostInput()" label="Operation Cost"
        placeholder="Operation Cost" suffix="€" />
    </div>
    <div class="col-sm-1 mw-field mt-2">
      <input-field type="number" [inputFormControl]="getItemIntroducerInput()" label="Introducer"
        placeholder="Introducer" suffix="%" />
    </div>
    <div class="col-sm-2 mt-2">
      <input-field type="number" [inputFormControl]="getItemMarginInput()" label="Margin" [readonly]="true"
        placeholder="Margin" suffix="€" />
    </div>
  </div>

  <div class="text-center mt-4">
    <button type="button" class="btn btn-success px-4 py-2" (click)="submitForm()">
      Save
    </button>
  </div>
</form>